"use strict";

exports.__esModule = true;
exports["default"] = getStyle;

var _lodash = require("lodash");

var _wixParams = require("../../constants/wix-params");

var _postPage = require("../../constants/post-page");

var _colors = require("../../services/colors");

function getStyle(appSettings, _ref) {
  var isPostPageEnabled = _ref.isPostPageEnabled,
      isBusinessManager = _ref.isBusinessManager;
  var textColor = (0, _colors.getSiteColor)(appSettings, {
    wixParam: _wixParams.POST_TEXT_COLOR,
    presetFallback: 'color-5',
    colorFallback: '#000'
  });
  var opaqueBackgroundColor = (0, _colors.getSiteColor)(appSettings, {
    wixParam: _wixParams.CARD_BACKGROUND_COLOR,
    presetFallback: 'color-1',
    colorFallback: '#fff',
    opacity: 1
  });
  var dividerColor = (0, _colors.setColorOpacity)(textColor, 0.2);
  var activeDividerColor = (0, _colors.setColorOpacity)(textColor, 0.5);
  var highlightedColor = isBusinessManager ? '#3899ec' : (0, _colors.getSiteColor)(appSettings, {
    wixParam: _wixParams.BUTTON_COLOR,
    presetFallback: 'color-8',
    colorFallback: '#3899ec',
    opacity: 1
  });
  var linkHashtagColor = (0, _colors.getSiteColor)(appSettings, {
    wixParam: _wixParams.LINK_AND_HASHTAG_COLOR,
    presetFallback: 'color-8',
    colorFallback: '#44C2BC'
  });
  var mobileFontSize = isPostPageEnabled ? (0, _lodash.get)(appSettings, _wixParams.POST_PAGE_FONT_SIZE_MOBILE_PATH, _postPage.DEFAULT_POST_PAGE_FONT_SIZE_MOBILE) : _postPage.DEFAULT_POST_PAGE_FONT_SIZE_MOBILE;
  var mobileHeaderTwoFontSize = (0, _lodash.get)(appSettings, _wixParams.POST_HEADER_TWO_FONT_SIZE_MOBILE_PATH, _postPage.DEFAULT_POST_HEADER_TWO_FONT_SIZE_MOBILE);
  var mobileHeaderThreeFontSize = (0, _lodash.get)(appSettings, _wixParams.POST_HEADER_THREE_FONT_SIZE_MOBILE_PATH, _postPage.DEFAULT_POST_HEADER_THREE_SIZE_MOBILE);
  var mobileQuotesFontSize = (0, _lodash.get)(appSettings, _wixParams.POST_QUOTES_FONT_SIZE_MOBILE_PATH, _postPage.DEFAULT_POST_QUOTES_SIZE_MOBILE);

  var _get = (0, _lodash.get)(appSettings, _wixParams.POST_PAGE_FONT_PATH, {
    size: 18
  }),
      textFontSize = _get.size;

  var headerTwoFontSize = Math.min(textFontSize + 10, 38);
  var headerThreeFontSize = Math.min(textFontSize + 4, 32);
  return {
    '--rce-text-color': textColor,
    '--rce-opaque-background-color': opaqueBackgroundColor,
    '--rce-divider-color': dividerColor,
    '--rce-active-divider-color': activeDividerColor,
    '--rce-highlighted-color': highlightedColor,
    '--rce-link-hashtag-color': linkHashtagColor,
    '--rce-mobile-font-size': mobileFontSize + "px",
    '--rce-header-two-font-size': headerTwoFontSize + "px",
    '--rce-header-three-font-size': headerThreeFontSize + "px",
    '--rce-mobile-header-two-font-size': mobileHeaderTwoFontSize + "px",
    '--rce-mobile-header-three-font-size': mobileHeaderThreeFontSize + "px",
    '--rce-mobile-quotes-font-size': mobileQuotesFontSize + "px"
  };
}